import config from 'app/config'

const clientTheme = config.system.name

const flinkePalette = {
  primary: {
    light: '#DCDCDC',
    main: '#515F65',
    dark: '#000000',
    contrastText: '#fff'
  },
  secondary: {
    veryLight: 'rgba(245, 245, 245, 1)',
    middleVeryLight: 'rgba(224, 224, 224, 1)',
    middleLight: 'rgba(189, 189, 189, 1)',
    light: 'rgba(164, 164, 164, 1)',
    main: 'rgba(117, 117, 117, 1)',
    dark: 'rgba(73, 73, 73, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  }
}

const syprePalette = {
  primary: {
    light: '#ffc966',
    main: '#F2A644',
    dark: '#cc7000',
    contrastText: '#fff'
  },
  secondary: {
    veryLight: 'rgba(245, 245, 245, 1)',
    middleVeryLight: 'rgba(224, 224, 224, 1)',
    middleLight: 'rgba(189, 189, 189, 1)',
    light: 'rgba(164, 164, 164, 1)',
    main: '#5A6273',
    dark: 'rgba(73, 73, 73, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  }
}

const maringaPrevidenciaPalette = {
  primary: {
    light: '#0BAB60',
    main: '#058F4F',
    dark: '#0b7240',
    contrastText: '#fff'
  },
  secondary: {
    veryLight: 'rgba(245, 245, 245, 1)',
    middleVeryLight: 'rgba(224, 224, 224, 1)',
    middleLight: 'rgba(189, 189, 189, 1)',
    light: 'rgba(164, 164, 164, 1)',
    main: 'rgba(117, 117, 117, 1)',
    dark: 'rgba(73, 73, 73, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  }
}

const zupcredPalette = {
  primary: {
    light: '#1A4040',
    main: '#1A4040',
    dark: '#0A1E1F',
    contrastText: '#FFFFFF'
  },
  secondary: {
    veryLight: 'rgba(245, 245, 245, 1)',
    middleVeryLight: '#E5E5E5',
    middleLight: 'rgba(189, 189, 189, 1)',
    light: '#E5E5E5',
    main: '#161A28',
    dark: '#0A1E1F',
    contrastText: '#FFFFFF'
  }
}

const senaprevPalette = {
  primary: {
    light: '#58B0A8',
    main: '#007068',
    dark: '#004F49',
    contrastText: '#fff'
  },
  secondary: {
    veryLight: 'rgba(245, 245, 245, 1)',
    middleVeryLight: 'rgba(224, 224, 224, 1)',
    middleLight: 'rgba(189, 189, 189, 1)',
    light: 'rgba(164, 164, 164, 1)',
    main: '#14403B',
    dark: 'rgba(73, 73, 73, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  }
}

const paletteByClient = {
  FLINKE: flinkePalette,
  SYPRE: syprePalette,
  MARINGA_PREVIDENCIA: maringaPrevidenciaPalette,
  ZUPCRED: zupcredPalette,
  SENAPREV: senaprevPalette,
  DEFAULT: flinkePalette
}

const palette = {
  ...(paletteByClient[clientTheme] || paletteByClient['DEFAULT']),
  common: {
    black: 'rgba(73, 73, 73, 1)',
    white: '#fff'
  },
  background: {
    paper: '#fff',
    default: '#f6f6f6'
  },
  info: {
    light: 'rgba(225, 245, 254, 1)',
    main: 'rgba(3, 169, 244, 1)',
    dark: 'rgba(73, 73, 73, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  blue: {
    main: 'rgba(32, 102, 171, 0.94)',
    light: 'rgba(6, 170, 244, 1)'
  },
  reds: {
    dark: '#b30b00'
  },
  success: {
    light: 'rgba(233, 245, 233, 1)',
    main: 'rgba(102, 187, 106, 1)',
    dark: 'rgba(102, 187, 106, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  purple: {
    middleLight: '#9575CD',
    light: 'rgba(225, 245, 254, 1)',
    main: 'rgba(149, 117, 205, 1)',
    dark: 'rgba(73, 73, 73, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  error: {
    light: 'rgba(245, 233, 233, 1)',
    main: '#f44336',
    dark: '#d32f2f',
    contrastText: '#fff',
    middleLight: 'rgba(255, 99, 71, 0.4)'
  },
  yellow: {
    light: '#f9c424',
    main: '#e6bb37'
  },
  warning: {
    light: '#FFECB3',
    main: '#FFC107',
    dark: '#FFC107',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  text: {
    main: 'rgba(73, 73, 73, 1)',
    primary: 'rgba(73, 73, 73, 1)',
    secondary: 'rgba(117, 117, 117, 1)',
    disabled: 'rgba(158, 158, 158, 1)',
    hint: 'rgba(0, 0, 0, 0.38)'
  },

  green: {
    middle: '#bce5be'
  },

  grey: {
    10: '#ffff',
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161',
    light: '#eeeeee',
    main: '#4f4f4f'
  },

  orange: {
    main: '#FF7043'
  }
}

export default palette
